import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export class MfPaymentStatusUseCases extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getmfPaymentStatus(req);
    }
}
export default MfPaymentStatusUseCases;
